<template>
  <b-row class="px-lg-2 px-4">
    <b-col cols="12" class="mb-4">
      <b-modal
        v-model="open"
        title="Apagar Serviço"
        size="lg"
        header-bg-variant="orange"
        header-text-variant="light"
        centered
        hide-footer
        no-close-on-backdrop
      >
      <b-row class="mt-3">
        <b-col cols="12">
          <div class="text-center">
            <h3>Deseja realmente excluir o serviço abaixo?:</h3>
            <h4 class="mt-2">{{ service.name }}</h4>
          </div>
        </b-col>
        <b-col cols="12" md="6" class="d-flex justify-content-end mt-5">
          <b-button
            variant="danger"
            block
            @click="open = false"
          >
          Cancelar
          </b-button>
        </b-col>
        <b-col cols="12" md="6" class="d-flex justify-content-end mt-5">
          <b-button
            variant="success"
            block
            @click="save()"
          >
          Sim
          </b-button>
        </b-col>
      </b-row>
      </b-modal>
    </b-col>
  </b-row>
</template>

<script>
export default {
  emits:['deleteService'],
 
  data() {
    return {
      loading: false,
      open: false,
      service: []
    }
  },

  methods: {
    toggleOpen(item) {
      this.open = !this.open;
      this.service = item.data;
    },
    save() {
      this.$emit('deleteService', this.service.id);
      this.open = !this.open;
    },
  }
}
</script>
